<template>
  <!-- Vuetify App Wrapper -->
  <v-app>
    <!-- App Bar -->
    <v-app-bar app class="nav-bar sticky-app-bar py-1" elevation="0">
      <v-container class="d-flex align-center justify-space-between">
        <!-- Logo -->
        <v-toolbar-title>Logo</v-toolbar-title>

        <!-- Hamburger Icon for Mobile -->
        <v-app-bar-nav-icon
          @click="drawer = !drawer"
          class="d-md-none"
        ></v-app-bar-nav-icon>

        <!-- Navigation Links for Desktop -->
        <div class="d-none d-md-flex align-center nav-bar">
          <router-link class="mr-2" to="/" exact>Home</router-link>
          <router-link class="mr-2" to="/about">About</router-link>
          <router-link class="mr-2" to="/services">Our Services</router-link>
          <router-link class="mr-2" to="/contact">Contact Us</router-link>
          <!-- <v-icon v-show="hideSearchIcon" @click="openSearch()"
            >mdi-magnify</v-icon
          > -->
          <!-- <v-text-field
            type="text"
            v-show="showSearch"
            v-model="searchQuery"
            @input="emitSearchQuery"
            placeholder="Search..."
            style="width: 250px"
            variant="outlined"
            density="compact"
            class="my-3"
            hide-details
          >
            <template v-slot:append-inner>
              <v-icon
                class="search-close-icon cursor-pointer"
                @click="searchQuery"
                >mdi-magnify</v-icon
              >
            </template>
          </v-text-field>

          <v-icon
            class="search-close-icon"
            v-show="hideSearchIcon"
            @click="openSearch()"
            >mdi-magnify</v-icon
          >
          <v-icon
            class="search-close-icon ml-2"
            v-show="showSearch"
            @click="closeSearch()"
            >mdi-close</v-icon
          > -->
        </div>
      </v-container>
    </v-app-bar>

    <!-- Navigation Drawer for Mobile -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      class="nav-bar d-md-none"
    >
      <v-list>
        <v-list-item>
          <router-link to="/" exact>Home</router-link>
        </v-list-item>
        <v-list-item>
          <router-link to="/about">About</router-link>
        </v-list-item>
        <v-list-item>
          <router-link to="/services">Our Services</router-link>
        </v-list-item>
        <v-list-item>
          <router-link to="/contact">Contact Us</router-link>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Main Content -->
    <v-main>
      <div>
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref } from "vue";

const drawer = ref(false);
// const showSearch = ref(false);
// const hideSearchIcon = ref(true);

// const openSearch = () => {
//   showSearch.value = !showSearch.value;
//   hideSearchIcon.value = !hideSearchIcon.value;
// };

// const closeSearch = () => {
//   showSearch.value = !showSearch.value;
//   hideSearchIcon.value = !hideSearchIcon.value;
// };
</script>
